import shiftBoxMiniIconsUrl from './shiftBoxMiniIcons.html';

class ShiftBoxMiniIconsController {
  constructor(
    AbsenceUtils,
    Authentication,
    AvailabilityUtils,
    ShiftTasksService,
    ShiftAcceptanceUtils,
    sdk
  ) {
    'ngInject';

    Object.assign(this, { AvailabilityUtils, AbsenceUtils, ShiftAcceptanceUtils });
    this.isManager = Authentication.user.isManager;
    this.UNAVAILABILITY_TYPE = sdk('constants').UNAVAILABILITY_TYPE;
    this.PLANNING_STATUS = sdk('constants').EVENT_STATUS.PLANNING;
    this.areShiftTasksAvailable = ShiftTasksService.isFeatureTurnedOn;
  }

  shouldRenderBigIcon() {
    const { showOfferedShiftIcon, showAvailableShiftIcon, showTimeoffIcon, exchangeData, slots } =
      this.event;
    return (
      showOfferedShiftIcon ||
      showAvailableShiftIcon ||
      showTimeoffIcon ||
      exchangeData?.isSwap ||
      slots > 1 ||
      this.AbsenceUtils.isAbsenceEvent(this.event) ||
      this.isPendingUnavailability()
    );
  }

  isPendingUnavailability() {
    return (
      this.event.type === this.UNAVAILABILITY_TYPE && this.AvailabilityUtils.isRequest(this.event)
    );
  }

  isShowingAcceptanceStatus() {
    return this.ShiftAcceptanceUtils.shouldShowAcceptanceStatus(this.event);
  }
}

export default {
  templateUrl: shiftBoxMiniIconsUrl,
  controller: ShiftBoxMiniIconsController,
  controllerAs: 'ctrl',
  bindings: {
    event: '<',
  },
};
